//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Browser from "@/wechat";
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    finish: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    gosrc: {
      type: String,
      default: ''
    },
    textname: {
      type: String,
      default: ''
    },
    havetextname: {
      type: Boolean,
      default: false
    },
  },
  components: {

  },
  data(){
    return {
      wechat: false,
    }
  },
  methods: {
    goback(path){
      this.$router.push({ name:path })
    },
    goto(path){
      this.$router.push({ name:path })
    },
  },
  mounted () {
    if (Browser.isWechat()) {
      this.wechat = true;
    } else {
      this.wechat = false;
    }
  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/components/units/topbar.vue